module.exports = __webpack_public_path__ + "img/aptitude16.0132e120.jpg";